import React from "react";
import Image from "@/bit/components/components.c-image";
import Link from "@/bit/components/components.custom-link";
import Text from "@/bit/components/components.text";

const ImageCardBig = (props) => {
  const { isSmall, cmsHandler, hideShadow } = props;

  return (
    <div
      className={`image-card ${
        isSmall ? "small aspect-ratio-7-5" : "big aspect-ratio-2-3"
      }`}
    >
      <Image fill objectFit="cover" {...props} cmsHandler={cmsHandler} />
      {!hideShadow && <div className="shadow" />}
      {/* <div className="card-content">
        {props["Text-1"] && <Text {...props["Text-1"]} />}
      </div>
      {props["Link-1"] && <Link {...props["Link-1"]} />} */}
    </div>
  );
};

export default ImageCardBig;
